import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTracking } from "react-tracking";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";
import AdminUserRoleRoutes from "./AdminUserRoleRoutes";

const AdminUserRoleRootScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Administration User Role",
      page: "Admin User Role Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );
  return (
    <div>
      <Track>
        <AdminUserRoleRoutes />
      </Track>
    </div>
  );
};

export default AdminUserRoleRootScreen;
